import { Component, OnInit, AfterViewInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

import { MediaMatcher } from '@angular/cdk/layout';
import { GlobalService } from '../../services/global.service';
import { Router } from '@angular/router';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/switchMap';


import * as firebase from 'firebase/app';
import { Subscription } from 'rxjs/Subscription';
import { ChatService } from './services/chat.service';

import * as linkifyHtml from 'linkifyjs/html';

declare var $: any;
declare var emojione: any;


@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.css']
})
export class ChatComponent implements OnInit, AfterViewInit {

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  is_opened = true;

  message: any;
  message_list: any[] = [];
  last_msg_key: any;
  is_msg_paging_end = false;
  isMsgLoaded = false;
  display_image: boolean;

  selected_msg: any;

  chat_loader: boolean;

  @ViewChild('sidenav') sidenav: any;

  constructor(
    public _globalService: GlobalService,
    public _chatService: ChatService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
  ) {
    this.mobileQuery = media.matchMedia('(max-width: 800px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    // console.log(this.mobileQuery, 'mobile query');

    // this._globalService.current_user_profile = JSON.parse(localStorage.getItem('current_user_profile'));
    // if (this._globalService.current_user_profile) {
    //   this._globalService.domain = this._globalService.current_user_profile.meta.orgid;
    // }

    this._globalService.domain = this._globalService.getDomain(this._globalService._fireAuth.auth.currentUser.email);

  }

  ngOnInit() {
    if (this.mobileQuery.matches) {
      this.is_opened = false;
    }
  }

  ngAfterViewInit() {
    $('#chatMessageBox').scroll(() => {
      // console.log('scrolllll', $('#chatMessageBox').scrollTop());
      if ($('#chatMessageBox').scrollTop() == 0) {

        // console.log('uppppppp');
        if (!this.is_msg_paging_end) {
          this.loadMoreMessage();
        }

      }
    });

    $('#emojionearea1').emojioneArea({
      pickerPosition: 'top',
      tonesStyle: 'bullet',
      saveEmojisAs: 'shortname',
      inline: true,
      events: {
        keyup: (editor, event) => {
          // console.log('event:keypress', event.which);
          if (event.which == 13) {
            // console.log('event:keypress2', event.which);
            this.sendMessage();

          }
        }
      }
    });

  }

  scrollToBottom() {
    const element = document.getElementById('chatMessageBox');
    $('#chatMessageBox').animate({
      scrollTop: element.scrollHeight
    }, 400);

    // element.scrollTop = (element.scrollHeight - element.clientHeight) + 200 ;
  }

  onKeyUp(ev) {
    if (ev.keyCode === 13) {
      this.sendMessage();
    }
  }

  onSelectMessage(msg) {
    this.selected_msg = msg;
    this.display_image = true;
  }

  selectThread(thread) {
    this._globalService.global_loader = true;
    this.is_msg_paging_end = false;
    this.message_list = [];
    this.last_msg_key = null;
    this.isMsgLoaded = false;
    $('#emojionearea1').emojioneArea()[0].emojioneArea.setText('');
    // console.log('select thread', thread);
    if (thread) {
      // update unseen count to 0
      this._globalService.updateUnseenCount(thread.thread_id, this._globalService._fireAuth.auth.currentUser.uid, 0);
      // end update unseen count to 0
      this._globalService.selected_thread = thread;
      this.getThreadDetails(thread);
      this.getThreadMessages(thread);
    }
  }

  getThreadDetails(thread) {

  }

  getThreadMessages(thread) {

    let startTime = new Date().getTime();

    // const messages_path = this._globalService.root_path + '/'
    //   + this._globalService.domain + '/threads/' + this._globalService.selected_thread.thread_id + '/messages';

    const messages_path = this._globalService.root_path + '/' + this._globalService.domain
      + '/messages/' + this._globalService.selected_thread.thread_id;

    // console.log(messages_path);

    if (this._globalService.message_subscription) {
      this._globalService.message_subscription.unsubscribe();
    }
    this._globalService.message_subscription = this._globalService._fireDB.list(messages_path, ref =>
      ref.orderByKey().limitToLast(15)).stateChanges(['child_added'])
      .subscribe(message => {
        // console.log('message ', message.payload.val());
        const payload = message.payload.val();
        if (payload.type === 0) {
          payload.payload = emojione.shortnameToImage(payload.payload);
          payload.payload = linkifyHtml(payload.payload);
        }
        this.message_list.push(payload);

        this.getTimeStamp();

        if (!this.last_msg_key) {
          this.last_msg_key = message.key;
        }

        if (new Date().getTime() - startTime > 500) {
          this.scrollToBottom();
        }
        startTime = new Date().getTime();


      });

    setTimeout(() => {
      // this.scrollToBottom();
      const element = document.getElementById('chatMessageBox');
      element.scrollTop = element.scrollHeight;
    }, 1000);

    setTimeout(() => {
      this.isMsgLoaded = true;
      this._globalService.global_loader = false;
      $('#emojionearea1').data('emojioneArea').editor.focus();
    }, 1000);

  }

  loadMoreMessage() {
    // const messages_path = this._globalService.root_path + '/'
    //   + this._globalService.domain + '/threads/' + this._globalService.selected_thread.thread_id + '/messages';

    const messages_path = this._globalService.root_path + '/' + this._globalService.domain
      + '/messages/' + this._globalService.selected_thread.thread_id;

    // console.log(this.last_msg_key, messages_path);
    if (this.last_msg_key) {
      this.chat_loader = true;
      this._globalService._fireDB.list(messages_path, ref =>
        ref.orderByKey().endAt(this.last_msg_key).limitToLast(16))
        .snapshotChanges()
        .first()
        .subscribe(message => {
          // console.log('more message ', message);
          if (message.length) {
            this.last_msg_key = message[0].key;
            for (let i = message.length - 2; i >= 0; i--) {
              const payload = message[i].payload.val();
              if (payload.type === 0) {
                payload.payload = emojione.shortnameToImage(payload.payload);
                payload.payload = linkifyHtml(payload.payload);
              }
              this.message_list.unshift(payload);
            }
            $('#chatMessageBox').scrollTop(150);

            if (message.length < 16) {
              this.is_msg_paging_end = true;
            }
          }
          this.getTimeStamp();
          this.chat_loader = false;
        },
        err => {
          this.chat_loader = false;
        });
    }
  }

  sendMessage() {
    let msg_clone = $('#emojionearea1').emojioneArea()[0].emojioneArea.getText();
    msg_clone = msg_clone.trim();

    this.message = '';
    $('#emojionearea1').emojioneArea()[0].emojioneArea.setText('');

    if (this._globalService.selected_thread && msg_clone) {
      this._chatService.sendMessage(msg_clone, 0)
        .then((resp) => {
          // console.log('send message success ', resp);

        }).catch(err => {
          console.log('send message error ', err);
        });
      this._chatService.onUnseenCount();
      this._chatService.onLastMessageAdded();
    }
  }

  getTimeStamp() {
    if (this.message_list.length) {
      this.message_list[0].showDate = true;
      for (let i = 0 ; i < this.message_list.length - 1 ; i++) {
        // console.log('timestamp', this.message_list[i].date ,
        //     new Date(this.message_list[i].date).getDate(), new Date(this.message_list[i + 1].date).getDate()  );
        if (new Date(this.message_list[i].date).getDate()
              !== new Date(this.message_list[i + 1].date).getDate() ) {
          this.message_list[i + 1].showDate = true;
        } else {
          this.message_list[i + 1].showDate = false;
        }
      }
    }
  }

  selectUserFromAddUser(user) {
    const fi = this._globalService.individual_thread_list.findIndex(th => th.user_id === user.authentication_id);

    if (fi >= 0) {
      this.selectThread(this._globalService.individual_thread_list[fi]);
      this._chatService.display_addFriend = false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/chat/chat.component.ts